var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconFeedbackNotHelpful(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "435npol2ra",
    d: "M6.667 0c3.676 0 6.666 2.99 6.666 6.667 0 3.676-2.99 6.666-6.666 6.666S0 10.343 0 6.667 2.99 0 6.667 0zm-.013 8c-.148 0-.297.008-.446.023-1.162.123-2.237.734-2.875 1.635l.58.342c.527-.745 1.414-1.25 2.374-1.35 1.231-.13 2.461.4 3.134 1.35L10 9.658C9.268 8.623 7.989 8 6.654 8zM4.667 4.667c-.369 0-.667.298-.667.666 0 .369.298.667.667.667.368 0 .666-.298.666-.667 0-.368-.298-.666-.666-.666zm4 0c-.369 0-.667.298-.667.666 0 .369.298.667.667.667.368 0 .666-.298.666-.667 0-.368-.298-.666-.666-.666z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-560.000000, -413.000000) translate(279.000000, 408.000000) translate(276.000000, 0.000000) translate(5.333333, 5.333333)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "5ezjvis0ub",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#435npol2ra"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    mask: "url(#5ezjvis0ub)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H16V16H0z",
    transform: "translate(-1.333333, -1.333333)"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFeedbackNotHelpful);
export default __webpack_public_path__ + "static/media/icon-feedback-not-helpful.8d53f647.svg";
export { ForwardRef as ReactComponent };